import React from 'react';
import Cronograma from '../../../components/ui/Admin/CronogramaComponents/Cronograma';

const CronogramaOperacionesUI = () => {
  return (
    <div className="pb-4">
      <Cronograma allowExtornar={false} apiBasePath="/api/operaciones" allowGroupSearch={false} />
    </div>
  );
};

export default CronogramaOperacionesUI;
